import { useSyncExternalStore } from 'react'

import { hasSession, signIn, signOut, subscribe } from '@/auth/session'

export function useAuth() {
  const isAuthenticated = useSyncExternalStore(subscribe, hasSession, hasSession)
  return { isAuthenticated, signIn, signOut }
}
